module.exports = __webpack_public_path__ + "img/38-02.347b44c5.png";